import { push } from '@lagunovsky/redux-react-router'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

export const useCountdown = (validity, sagaCall, redirectTo) => {
    const [minutes, setMinutes] = useState(0)
    const dispatch = useDispatch()

    const oneSecond = 1000

    const updateMinutesLeft = () => {
        const now = new Date()
        const basketValidity = new Date(validity)

        if (now <= basketValidity) {
            const timeDiff = basketValidity.getTime() - now.getTime()
            const minutesLeft = Math.ceil(timeDiff / (oneSecond * 60))
            setMinutes(minutesLeft)

            // setted 5 seconds for some buggy issues
            if (timeDiff <= oneSecond * 5) {
                dispatch(push(`/${redirectTo}`))
                sagaCall()
            }
        } else {
            setMinutes(0)
        }
    }

    useEffect(() => {
        updateMinutesLeft()

        const countdownInterval = setInterval(() => {
            updateMinutesLeft()
        }, oneSecond)

        return () => clearInterval(countdownInterval)
    }, [validity])

    return minutes
}
